export enum SearchParamsKeysEnum {
  game_id = 'game_id',
  lang = 'lang',
  token = 'token',
}
